/* ═══════════════════════════════════════════════════════════════════════
   uwelle® · ficha editorial de producto · comportamiento
   Tres piezas: el parallax de tres capas (regla 8.2), la galería de la
   cabecera en dos modos y la barra de compra que aparece en el teléfono.

   Todo va con alcance a la raíz de la sección, no al documento: la ficha
   convive con la cabecera y el pie del tema, y el editor de temas reinyecta
   secciones sueltas sin recargar la página. Cada arranque se registra para
   poder deshacerse cuando la sección se va.

   23 sep 2026 · Los <li> de la tira cambian de papel con el modo. En
   escritorio la tira es una lista de pestañas y los <li> van como
   `presentation`, porque un tablist solo puede contener pestañas. En el
   teléfono la tira vuelve a ser una lista, y ahí un <li> sin papel de
   elemento de lista la rompe: se les quita el atributo.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var VEL = { tex: 0.16, mod: 0.075, txt: -0.035 };
  var HOL = { tex: 0.08, mod: 0.08 };
  var vivos = new WeakMap();

  function reduce() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function arrancar(raiz) {
    if (!raiz || vivos.has(raiz)) return;
    try {
      arrancarDeVerdad(raiz);
    } catch (e) {
      /* Regla: el movimiento es un lujo, leer la ficha no. Si algo revienta
         aquí dentro, se retira la clase de animación y la página se queda
         visible y usable, con el error a la vista en la consola. */
      raiz.classList.remove('is-js');
      raiz.dataset.uwListo = '1';
      Array.prototype.forEach.call(raiz.querySelectorAll('.u-rv,.u-stg'), function (n) {
        n.classList.add('u-in');
      });
      if (window.console) console.error('[uwelle-ficha] arranque fallido:', e);
    }
  }

  function arrancarDeVerdad(raiz) {

    raiz.classList.add('is-js');

    var quitar = [];
    function on(obj, ev, fn, opt) {
      obj.addEventListener(ev, fn, opt);
      quitar.push(function () { obj.removeEventListener(ev, fn, opt); });
    }

    /* ── 1 · parallax de tres capas ──────────────────────────────────────
       El recorrido no se le quita a la pieza: se le añade a la imagen. El
       tope se MIDE en píxeles —cuánto sobresale el elemento de su ventana—
       y nunca se estima. Un elemento sin holgura se queda quieto.        */
    var capas = [];
    function medir() {
      capas = [];
      if (reduce()) return;
      Array.prototype.slice.call(raiz.querySelectorAll('[data-px]')).forEach(function (el) {
        var t = el.getAttribute('data-px');
        if (!VEL.hasOwnProperty(t)) return;
        var caja = t === 'txt' ? el : el.parentElement;
        if (!caja) return;
        var alto = caja.getBoundingClientRect().height;
        if (!alto) return;
        var tope;
        if (t === 'txt') {
          tope = Math.min(Math.abs(VEL.txt) * alto, 16);
        } else {
          var t0 = el.style.transform;
          el.style.transform = 'none';
          var sobra = el.getBoundingClientRect().height - alto;
          el.style.transform = t0;
          tope = Math.min(VEL[t] * alto, sobra / 2 - 1, HOL[t] * alto - 1);
        }
        if (tope > 0.5) capas.push({ el: el, caja: caja, tope: tope, signo: VEL[t] < 0 ? -1 : 1 });
      });
    }
    function pintarPx() {
      var vh = window.innerHeight;
      for (var i = 0; i < capas.length; i++) {
        var c = capas[i], r = c.caja.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue;
        var p = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
        if (p > 1) p = 1; else if (p < -1) p = -1;
        c.el.style.transform = 'translate3d(0,' + (p * c.tope * c.signo).toFixed(2) + 'px,0)';
      }
    }

    /* ── 2 · entradas al hacer scroll ─────────────────────────────────── */
    var io = ('IntersectionObserver' in window) && !reduce()
      ? new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('u-in'); io.unobserve(e.target); }
          });
        }, { rootMargin: '0px 0px -8% 0px' })
      : null;
    function entradas() {
      var n = raiz.querySelectorAll('.u-rv:not(.u-in),.u-stg:not(.u-in)');
      if (!io) { Array.prototype.forEach.call(n, function (e) { e.classList.add('u-in'); }); return; }
      Array.prototype.forEach.call(n, function (e) { io.observe(e); });
    }

    /* ── 3 · barra de compra en el teléfono ───────────────────────────── */
    var barra = raiz.querySelector('[data-uw-barra]'), puesta = false;
    function pintarBarra() {
      if (!barra) return;
      var debe = window.scrollY > window.innerHeight * 0.85;
      if (debe === puesta) return;
      puesta = debe;
      barra.classList.toggle('is-in', debe);
    }

    function remedir() { medir(); pintarPx(); }

    /* ── 4 · la galería de la cabecera ────────────────────────────────────
       Dos modos con el mismo marcado. En escritorio es un tablist: los
       slots están todos en el documento y sólo uno se muestra. En el
       teléfono es un carrusel que se desliza con el dedo. Los papeles ARIA
       cambian con el modo: un carrusel deslizable no es una lista de
       pestañas, y anunciarlo como tal sería mentirle al lector.          */
    var tira = raiz.querySelector('.d-tira');
    var pila = raiz.querySelector('.d-gal__pila');
    var minis = tira ? Array.prototype.slice.call(tira.querySelectorAll('.d-mini')) : [];
    var renglones = tira ? Array.prototype.slice.call(tira.children) : [];
    var slides = pila ? Array.prototype.slice.call(pila.querySelectorAll('.d-slide')) : [];
    var mq = window.matchMedia('(max-width:860px)');
    var actual = 0;

    function movil() { return mq.matches; }

    function pintar(i, centrar) {
      actual = i;
      minis.forEach(function (b, k) {
        var sel = k === i;
        if (movil()) { b.setAttribute('aria-current', sel ? 'true' : 'false'); }
        else { b.setAttribute('aria-selected', String(sel)); }
        b.tabIndex = sel ? 0 : -1;
      });
      if (centrar !== false && minis[i] && minis[i].scrollIntoView) {
        minis[i].scrollIntoView({ block: 'nearest', inline: 'center' });
      }
    }

    function mostrar(i, foco) {
      if (movil()) {
        var x = slides[i].offsetLeft - slides[0].offsetLeft;
        if (pila.scrollTo) pila.scrollTo({ left: x, behavior: 'smooth' });
        else pila.scrollLeft = x;
      } else {
        slides.forEach(function (s, k) { s.hidden = k !== i; });
      }
      pintar(i);
      if (foco && minis[i]) minis[i].focus();
      remedir();
    }

    function aplicarModo() {
      if (!tira || !pila) return;
      if (movil()) {
        tira.removeAttribute('role');
        renglones.forEach(function (li) { li.removeAttribute('role'); });
        minis.forEach(function (b, k) {
          b.removeAttribute('role'); b.removeAttribute('aria-selected');
          b.setAttribute('aria-current', k === actual ? 'true' : 'false');
          b.setAttribute('aria-label', 'Ver la vista ' + (k + 1) + ' de ' + minis.length);
        });
        slides.forEach(function (s, k) {
          s.hidden = false;
          s.setAttribute('role', 'group');
          s.setAttribute('aria-roledescription', 'diapositiva');
          s.setAttribute('aria-label', (k + 1) + ' de ' + slides.length);
        });
        pila.setAttribute('tabindex', '0');
        pila.setAttribute('aria-label', 'Vistas del producto · desliza para ver las demás');
      } else {
        tira.setAttribute('role', 'tablist');
        renglones.forEach(function (li) { li.setAttribute('role', 'presentation'); });
        minis.forEach(function (b, k) {
          b.setAttribute('role', 'tab');
          b.removeAttribute('aria-current'); b.removeAttribute('aria-label');
          b.setAttribute('aria-selected', String(k === actual));
        });
        slides.forEach(function (s, k) {
          s.setAttribute('role', 'tabpanel');
          s.removeAttribute('aria-roledescription'); s.removeAttribute('aria-label');
          s.hidden = k !== actual;
        });
        pila.removeAttribute('tabindex'); pila.removeAttribute('aria-label');
      }
      remedir();
    }

    if (tira && pila && slides.length) {
      var pendGal = false;
      on(pila, 'scroll', function () {
        if (!movil() || pendGal) return;
        pendGal = true;
        requestAnimationFrame(function () {
          pendGal = false;
          var centro = pila.scrollLeft + pila.clientWidth / 2, mejor = 0, dmin = Infinity;
          slides.forEach(function (s, k) {
            var c = s.offsetLeft - slides[0].offsetLeft + s.offsetWidth / 2;
            var d = Math.abs(c - centro);
            if (d < dmin) { dmin = d; mejor = k; }
          });
          if (mejor !== actual) pintar(mejor);
        });
      }, { passive: true });

      minis.forEach(function (b, i) {
        on(b, 'click', function () { mostrar(i); });
        on(b, 'keydown', function (e) {
          var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1
            : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          mostrar((i + d + minis.length) % minis.length, true);
        });
      });

      if (mq.addEventListener) on(mq, 'change', aplicarModo);
      else if (mq.addListener) mq.addListener(aplicarModo);

      aplicarModo();
      pintar(0, false);
    }

    /* ── 5 · el acordeón de beneficios ───────────────────────────────────
       Al abrir uno se cierra el anterior, y si el anterior estaba más
       arriba la página da un salto: la fila que acabas de tocar se te va de
       debajo del dedo. Se anota dónde estaba la fila antes de abrir y se
       corrige el scroll por la diferencia.                               */
    Array.prototype.forEach.call(raiz.querySelectorAll('.d-b'), function (d) {
      var antes = null;
      on(d, 'click', function (e) {
        if (e.target.closest && e.target.closest('summary')) antes = d.getBoundingClientRect().top;
      }, true);
      on(d, 'toggle', function () {
        if (d.open && antes !== null) {
          var salto = d.getBoundingClientRect().top - antes;
          if (Math.abs(salto) > 2) window.scrollBy(0, salto);
        }
        antes = null;
        remedir();
      });
    });

    /* ── 6 · un solo oyente de scroll para toda la sección ───────────── */
    var pend = false;
    on(window, 'scroll', function () {
      if (pend) return;
      pend = true;
      requestAnimationFrame(function () { pend = false; pintarPx(); pintarBarra(); });
    }, { passive: true });
    on(window, 'resize', function () { remedir(); pintarBarra(); }, { passive: true });
    on(window, 'load', remedir);

    /* las fuentes llegan después del primer pintado y mueven las alturas */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remedir);

    if (barra) barra.hidden = false;
    remedir();
    pintarBarra();
    entradas();

    vivos.set(raiz, function () {
      quitar.forEach(function (f) { f(); });
      if (io) io.disconnect();
    });

    /* El arranque llegó entero: ahora sí se desarma el vigía. */
    raiz.dataset.uwListo = '1';
  }

  function apagar(raiz) {
    var f = vivos.get(raiz);
    if (f) { f(); vivos.delete(raiz); }
  }

  function barrer(ambito) {
    Array.prototype.forEach.call((ambito || document).querySelectorAll('.uw-ficha'), arrancar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { barrer(); });
  } else {
    barrer();
  }

  /* el editor de temas reinyecta secciones sin recargar la página */
  document.addEventListener('shopify:section:load', function (e) { barrer(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('.uw-ficha'), apagar);
  });
})();